import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingGenplanPreview } from '../../components/NewbuildingGenplanPreview';
import { getGenplan, getNewbuildingId } from '../../selectors/newbuildingHeader';
import { trackMediaItemClick } from '../../tracking/newbuilding';
import { NewbuildingGenplanModalContainerLoadable } from '../NewbuildingGenplanModal';

export const NewbuildingGenplanContainer: React.FC = () => {
  const [isOpened, setOpened] = React.useState<boolean>(false);

  const genplan = useSelector(getGenplan);
  const newbuildingId = useSelector(getNewbuildingId);

  const handleClick = React.useCallback(() => {
    setOpened(true);

    if (newbuildingId) {
      trackMediaItemClick({ target: 'building_plan', newbuildingId });
    }
  }, [newbuildingId]);

  const handleClose = React.useCallback(() => {
    setOpened(false);
  }, []);

  if (!genplan) {
    return null;
  }

  const { imageUrl } = genplan;

  return (
    <>
      <NewbuildingGenplanPreview onClick={handleClick} imageUrl={imageUrl} />
      {isOpened && <NewbuildingGenplanModalContainerLoadable isOpened={isOpened} onClose={handleClose} />}
    </>
  );
};
